import script from "./X1DatatablePaginatorend.vue?vue&type=script&lang=ts&setup=true"
export * from "./X1DatatablePaginatorend.vue?vue&type=script&lang=ts&setup=true"

import "./X1DatatablePaginatorend.vue?vue&type=style&index=0&id=7c66e156&lang=scss&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c66e156"]])

export default __exports__